import { getCurrentMonthInNumericFormat } from "common";
import dayjs from "dayjs";

interface CardProps {
    id?: ID;
    brand?: string;
    expMonth: number;
    expYear: number;
    funding?: string;
    last4?: string;
    postcode?: string;
    seller?: { id: ID };
}

export const isExpired = (card: CardProps, timezoneName: string) => {
    const currentMonth = getCurrentMonthInNumericFormat(timezoneName);
    const currentYear = dayjs().tz(timezoneName).year();

    return card.expYear < currentYear || (card.expYear === currentYear && card.expMonth < currentMonth);
};
